var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "realname",
      "label": "姓名"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('realname');
      }
    },
    model: {
      value: _vm.data.realname,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "realname", $$v);
      },
      expression: "data.realname"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('mobile');
      }
    },
    model: {
      value: _vm.data.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "mobile", $$v);
      },
      expression: "data.mobile"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "email",
      "label": "邮箱"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('email');
      }
    },
    model: {
      value: _vm.data.email,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "email", $$v);
      },
      expression: "data.email"
    }
  })], 1), _vm.title !== '账号信息' ? _c('FormItem', {
    attrs: {
      "prop": "max_point_num",
      "label": "最大试用点数"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "number"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('max_point_num');
      }
    },
    model: {
      value: _vm.data.max_point_num,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "max_point_num", $$v);
      },
      expression: "data.max_point_num"
    }
  })], 1) : _vm._e(), _vm.title !== '账号信息' ? _c('FormItem', {
    attrs: {
      "prop": "max_trial_days",
      "label": "最大试用天数"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "number"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('max_trial_days');
      }
    },
    model: {
      value: _vm.data.max_trial_days,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "max_trial_days", $$v);
      },
      expression: "data.max_trial_days"
    }
  })], 1) : _vm._e(), _c('FormItem', {
    attrs: {
      "prop": "employer",
      "label": "公司"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('employer');
      }
    },
    model: {
      value: _vm.data.employer,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "employer", $$v);
      },
      expression: "data.employer"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "job_title",
      "label": "岗位"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('job_title');
      }
    },
    model: {
      value: _vm.data.job_title,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "job_title", $$v);
      },
      expression: "data.job_title"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('remark');
      }
    },
    model: {
      value: _vm.data.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "remark", $$v);
      },
      expression: "data.remark"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };